"use es6";

const instantAnimationState = {
  current: false
};
export { instantAnimationState };